import React from "react";

const RecentBlogs = () => {
  return (
    <section
      className="recent-blogs overflow-x-hidden sm:overflow-x-auto"
      id="recent-blogs"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="block lg:flex lg:justify-between items-center lg:mb-4 lg:pb-4 lg:pt-[10.5rem] md:pt-24 pt-14">
          <div className="2xl:max-w-4xl lg:max-w-3xl">
            <div className="lg:overflow-hidden">
              <h2 className="font-bold sentence-first-letter text-4xl xl:text-5xl 2xl:text-6xl tracking-[-2px] lg:-translate-y-[7px] xl:!leading-[55px] 2xl:!leading-[65px]">
                {" "}
                <span>our blogs</span>{" "}
              </h2>{" "}
            </div>
          </div>
          <a
            className=" mt-6 text-black text-md lg:text-xl inline-flex items-center gap-4 group transition-all duration-300 ease-in-out hover:font-semibold"
            href="#"
          >
            View All
            <div className="transform group-hover:translate-x-2 transition-all duration-300 ease-in-out header-menu-item">
              <img
                src="/assets/images/arrow.svg"
                className="block group-hover:hidden w-5 lg:w-full"
                alt="link arrow"
              />
              <img
                src="/assets/images/arrow.svg"
                className="hidden group-hover:block w-5 lg:w-full"
                alt="link arrow"
              />{" "}
            </div>{" "}
          </a>{" "}
        </div>
        <div className="mx-auto md:mt-0 md:mx-0 md:max-w-none">
          <div className="md:flex pt-12">
            <a
              className="md:w-[41%]"
              rel="noreferrer"
              href="#"
            >
              <article className="cursor-pointer pb-8 w-full">
                <div className=" h-[200px] sm:h-[250px] md:h-[230px] lg:h-[315px] first-line:group overflow-hidden lg:rounded-[30px] rounded-2xl ">
                  <div className="inline-flex overflow-hidden h-full w-full">
                    <img
                      src="/assets/images/blogs/Best-Models-for-Stable-Diffusion-in-2025.webp"
                      className="h-full w-full lg:rounded-[30px] rounded-2xl group-hover:scale-110 ease-in object-cover overflow-hidden transform transition-transform duration-300"
                      alt="Best Models for Stable Diffusion in 2025"
                    />
                  </div>
                </div>
                <p className=" pt-3 md:pt-4 lg:pb-1 pb-2 md:pb-3 flex items-center font-medium text-sm lg:text-md xl:text-lg 2xl:text-xl">
                  {" "}
                  Artificial Intelligence
                  {/* */}
                  <span />{" "}
                </p>
                <div className="h-[8px] mt-[-22px] px-3 pb-2.5 text-2xl text-[#6F6F6F] rounded-full font-black">
                  {" "}
                  .
                </div>
                <span className="text-[#6F6F6F]">
                  {" "}
                  <p className=" text-[#6F6F6F] font-medium md:mt-[2px] text-xs xl:text-sm 2xl:text-base">
                    {" "}
                    10 Feb, 2025
                  </p>{" "}
                </span>
                <p />
                <h3 className=" font-medium line-clamp-3 lg:mt-3 decoration-2 underline-offset-4 hover:underline text-xl xl:text-2xl 2xl:text-3xl tracking-[0px]">
                  {" "}
                  Best Model for Stable Diffusion in 2025
                </h3>{" "}
              </article>
            </a>
            <a
              className="md:w-[28%] md:mt-24 md:mx-[3%]"
              rel="noreferrer"
              href="#"
            >
              <article className="cursor-pointer pb-8 full">
                <div className=" h-[200px] sm:h-[250px] md:h-[135px] lg:h-[220px] first-line:group overflow-hidden lg:rounded-[30px] rounded-2xl ">
                  <div className="inline-flex overflow-hidden h-full w-full">
                    <img
                      src="/assets/images/blogs/How-Much-Does-Artificial-Intelligence-Cost-in-2025.webp"
                      className="h-full w-full lg:rounded-[30px] rounded-2xl group-hover:scale-110 ease-in object-cover overflow-hidden transform transition-transform duration-300"
                      alt="Artificial Intelligence Cost"
                    />
                  </div>
                </div>
                <p className=" pt-3 md:pt-4 lg:pb-1 pb-2 md:pb-3 flex items-center font-medium text-sm lg:text-md xl:text-lg 2xl:text-xl">
                  {" "}
                  Artificial Intelligence
                  {/* */}
                  <span />{" "}
                </p>
                <div className="h-[8px] mt-[-22px] px-3 pb-2.5 text-2xl text-[#6F6F6F] rounded-full font-black">
                  {" "}
                  .
                </div>
                <span className="text-[#6F6F6F]">
                  {" "}
                  <p className=" text-[#6F6F6F] font-medium md:mt-[2px] text-xs xl:text-sm 2xl:text-base">
                    {" "}
                    6 Feb, 2025
                  </p>{" "}
                </span>
                <p />
                <h3 className=" font-medium line-clamp-3 lg:mt-3 decoration-2 underline-offset-4 hover:underline text-xl xl:text-2xl 2xl:text-3xl tracking-[0px]">
                  {" "}
                  AI Pricing: How Much Does Artificial Intelligence Cost in
                  2025?
                </h3>{" "}
              </article>
            </a>
            <a
              className="md:w-[28%]"
              rel="noreferrer"
              href="#"
            >
              <article className="cursor-pointer pb-8 w-full">
                <div className=" h-[200px] sm:h-[250px] md:h-[135px] lg:h-[220px] first-line:group overflow-hidden lg:rounded-[30px] rounded-2xl ">
                  <div className="inline-flex overflow-hidden h-full w-full">
                    <img
                      src="/assets/images/blogs/How-Can-Generative-AI-Be-Used-in-Cybersecurity-in-2025.webp"
                      className="h-full w-full lg:rounded-[30px] rounded-2xl group-hover:scale-110 ease-in object-cover overflow-hidden transform transition-transform duration-300"
                      alt="Generative AI in Cybersecurity"
                    />
                  </div>
                </div>
                <p className=" pt-3 md:pt-4 lg:pb-1 pb-2 md:pb-3 flex items-center font-medium text-sm lg:text-md xl:text-lg 2xl:text-xl">
                  {" "}
                  Artificial Intelligence
                  {/* */}
                  <span />{" "}
                </p>
                <div className="h-[8px] mt-[-22px] px-3 pb-2.5 text-2xl text-[#6F6F6F] rounded-full font-black">
                  {" "}
                  .
                </div>
                <span className="text-[#6F6F6F]">
                  {" "}
                  <p className=" text-[#6F6F6F] font-medium md:mt-[2px] text-xs xl:text-sm 2xl:text-base">
                    {" "}
                    4 Feb, 2025
                  </p>{" "}
                </span>
                <p />
                <h3 className=" font-medium line-clamp-3 lg:mt-3 decoration-2 underline-offset-4 hover:underline text-xl xl:text-2xl 2xl:text-3xl tracking-[0px]">
                  {" "}
                  How Can Generative AI Be Used in Cybersecurity in 2025?
                </h3>{" "}
              </article>
            </a>
          </div>
          <div className="md:flex md:pt-12">
            <a
              className="md:w-[28%]"
              rel="noreferrer"
              href="#"
            >
              <article className="cursor-pointer pb-8 w-full">
                <div className=" h-[200px] sm:h-[250px] md:h-[135px] lg:h-[220px] first-line:group overflow-hidden lg:rounded-[30px] rounded-2xl ">
                  <div className="inline-flex overflow-hidden h-full w-full">
                    <img
                      src="/assets/images/blogs/Best-Open-Source-LLMs-for-Code-Generation-in-2025.webp"
                      className="h-full w-full lg:rounded-[30px] rounded-2xl group-hover:scale-110 ease-in object-cover overflow-hidden transform transition-transform duration-300"
                      alt="Best Open Source LLMs for Code Generation in 2025"
                    />{" "}
                  </div>
                </div>
                <p className=" pt-3 md:pt-4 lg:pb-1 pb-2 md:pb-3 flex items-center font-medium text-sm lg:text-md xl:text-lg 2xl:text-xl">
                  {" "}
                  Artificial Intelligence
                  {/* */}
                  <span />{" "}
                </p>
                <div className="h-[8px] mt-[-22px] px-3 pb-2.5 text-2xl text-[#6F6F6F] rounded-full font-black">
                  {" "}
                  .
                </div>
                <span className="text-[#6F6F6F]">
                  {" "}
                  <p className=" text-[#6F6F6F] font-medium md:mt-[2px] text-xs xl:text-sm 2xl:text-base">
                    {" "}
                    3 Feb, 2025
                  </p>{" "}
                </span>
                <p />
                <h3 className=" font-medium line-clamp-3 lg:mt-3 decoration-2 underline-offset-4 hover:underline text-xl xl:text-2xl 2xl:text-3xl tracking-[0px]">
                  {" "}
                  Best Open Source LLMs for Code Generation in 2025
                </h3>{" "}
              </article>
            </a>
            <a
              className="md:w-[28%] md:mt-24 md:mx-[3%]"
              rel="noreferrer"
              href="#"
            >
              <article className="cursor-pointer pb-8 w-full">
                <div className=" h-[200px] sm:h-[250px] md:h-[135px] lg:h-[220px] first-line:group overflow-hidden lg:rounded-[30px] rounded-2xl ">
                  <div className="inline-flex overflow-hidden h-full w-full">
                    <img
                      src="https://resources.cubix.co/wp-content/uploads/2025/01/DeepSeek-vs-ChatGPT-–-How-Do-These-LLMs-Compare-in-2025.webp"
                      className="h-full w-full lg:rounded-[30px] rounded-2xl group-hover:scale-110 ease-in object-cover overflow-hidden transform transition-transform duration-300"
                      alt="DeepSeek vs ChatGPT - A Detailed Comparison"
                    />
                  </div>
                </div>
                <p className=" pt-3 md:pt-4 lg:pb-1 pb-2 md:pb-3 flex items-center font-medium text-sm lg:text-md xl:text-lg 2xl:text-xl">
                  {" "}
                  Artificial Intelligence
                  {/* */}
                  <span />{" "}
                </p>
                <div className="h-[8px] mt-[-22px] px-3 pb-2.5 text-2xl text-[#6F6F6F] rounded-full font-black">
                  {" "}
                  .
                </div>
                <span className="text-[#6F6F6F]">
                  {" "}
                  <p className=" text-[#6F6F6F] font-medium md:mt-[2px] text-xs xl:text-sm 2xl:text-base">
                    {" "}
                    31 Jan, 2025
                  </p>{" "}
                </span>
                <p />
                <h3 className=" font-medium line-clamp-3 lg:mt-3 decoration-2 underline-offset-4 hover:underline text-xl xl:text-2xl 2xl:text-3xl tracking-[0px]">
                  {" "}
                  DeepSeek vs ChatGPT – How Do These LLMs Compare in 2025?
                </h3>{" "}
              </article>
            </a>
            <a
              className="md:w-[41%]"
              rel="noreferrer"
              href="#"
            >
              <article className="cursor-pointer pb-8 w-full">
                <div className=" h-[200px] sm:h-[250px] md:h-[230px] lg:h-[315px] first-line:group overflow-hidden lg:rounded-[30px] rounded-2xl ">
                  <div className="inline-flex overflow-hidden h-full w-full">
                    <img
                      src="https://resources.cubix.co/wp-content/uploads/2025/01/How-to-Build-an-LLM-Like-DeepSeek.webp"
                      className="h-full w-full lg:rounded-[30px] rounded-2xl group-hover:scale-110 ease-in object-cover overflow-hidden transform transition-transform duration-300"
                      alt="How to Build an LLM Like DeepSeek?"
                    />
                  </div>
                </div>
                <p className=" pt-3 md:pt-4 lg:pb-1 pb-2 md:pb-3 flex items-center font-medium text-sm lg:text-md xl:text-lg 2xl:text-xl">
                  {" "}
                  Artificial Intelligence
                  {/* */}
                  <span />{" "}
                </p>
                <div className="h-[8px] mt-[-22px] px-3 pb-2.5 text-2xl text-[#6F6F6F] rounded-full font-black">
                  {" "}
                  .
                </div>
                <span className="text-[#6F6F6F]">
                  {" "}
                  <p className=" text-[#6F6F6F] font-medium md:mt-[2px] text-xs xl:text-sm 2xl:text-base">
                    {" "}
                    29 Jan, 2025
                  </p>{" "}
                </span>
                <p />
                <h3 className=" font-medium line-clamp-3 lg:mt-3 decoration-2 underline-offset-4 hover:underline text-xl xl:text-2xl 2xl:text-3xl tracking-[0px]">
                  {" "}
                  How to Build an LLM Like DeepSeek?
                </h3>{" "}
              </article>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecentBlogs;
